/* global */
import './style.less';

export default function($log, $stateParams, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  function activate() {
    $log.debug('Admin Attachments Activated');

    vm.loaded = false;
    vm.error = {};
    ApiClass.usersAttachmentsGet(undefined, undefined, { queryParams: { manage: true } })
      .then(({ data: { items: attachments } }) => {
        $log.debug('Firm Attachments Data', attachments);

        vm.attachments = attachments;

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/attachments/get/index.js